<template>
  <div id="Contact" class="footer">
    <div class="warpper">
      <div class="contact-us">
        <h3>{{ $t("contact.title") }}</h3>
        <div class="welcome">
          <p>{{ $t("contact.content") }}</p>
        </div>
        <div class="contact-info">
          <div class="email">
            <img :src="'/imgs/youjian.png'" alt="Email" :style="{ width: iconSize + 'px', height: iconSize + 'px' }"/>
            <span :style="{ fontSize: textSize + 'px', lineHeight: (textSize * 1.4) + 'px' }">{{ $t("contact.email") }}: info@bitgo.capital</span>
          </div>
          <div class="website">
            <img :src="'/imgs/wangluo.png'" alt="Website" :style="{ width: iconSize + 'px', height: iconSize + 'px' }"/>
            <span :style="{ fontSize: textSize + 'px', lineHeight: (textSize * 1.4) + 'px' }">{{ $t("contact.website") }}: www.bitgo.capital</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      windowWidth: 0,
      windowHeight: 0
    };
  },
  computed: {
    // 计算图标大小
    iconSize() {
      const baseRatio = 0.03;
      const minSize = 20;
      const maxSize = 40;
      const calculatedSize = this.windowWidth * baseRatio;
      return Math.min(Math.max(calculatedSize, minSize), maxSize);
    },
    // 计算文字大小
    textSize() {
      const baseRatio = 0.025;
      const minSize = 16;
      const maxSize = 30;
      const calculatedSize = this.windowWidth * baseRatio;
      return Math.min(Math.max(calculatedSize, minSize), maxSize);
    }
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
      });
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style lang="less" scoped>
.warpper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-left: 10px;
}

.footer {
  position: relative;
  background: #031A3A;
  min-height: 30vh;

  .contact-us {
    color: #FFFFFF;
    width: 100%;
    // 移除所有左侧内边距，确保内容贴左
    padding-left: 0 !important;
    margin-left: 0 !important;

    h3 {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-weight: 500;
      font-size: clamp(24px, 4vw, 46px);
      line-height: 1.4;
      text-align: left;
      font-style: normal;
      padding-top: clamp(20px, 3vh, 50px);
      // 强制左对齐
      margin: 0 !important;
      padding: clamp(20px, 3vh, 50px) 0 0 0 !important;
    }

    .welcome {
      padding: clamp(30px, 5vh, 80px) 0 0 0 !important;
      margin: 0 !important;

      p {
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        font-weight: 400;
        font-size: clamp(16px, 2.5vw, 30px);
        line-height: 1.4;
        text-align: left;
        font-style: normal;
        margin: 0 0 10px 0 !important;
        padding: 0 !important;
      }
    }

    .contact-info {
      padding: clamp(20px, 3vh, 50px) 0 clamp(30px, 5vh, 104px) 0 !important;
      margin: 0 !important;

      .email,
      .website {
        display: flex;
        align-items: center;
        margin: 0 0 15px 0 !important;
        padding: 0 !important;
        // 防止在小屏幕上换行
        flex-wrap: nowrap;

        img {
          margin: 0 !important;
          padding: 0 !important;
          // 确保图片不会缩小
          flex-shrink: 0;
        }

        span {
          font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
          font-weight: 400;
          font-size: clamp(16px, 2.5vw, 30px);
          line-height: 1.4;
          text-align: left;
          font-style: normal;
          // 最小化文字与图标的间距
          padding-left: 5px !important;
          margin: 0 !important;
          // 确保文字不会被压缩
          flex-shrink: 0;
          // 文字过长时允许换行
          word-break: break-word;
        }
      }
    }
  }
}

/* 响应式设计 - 保持水平排列 */
@media (max-width: 768px) {
  .warpper {
    width: 90%;
    margin: 0 auto;
  }

  .footer {
    .contact-us {
      padding-left: 0 !important;

      .contact-info {
        .email,
        .website {
          // 保持水平排列，移除垂直排列样式
          flex-direction: row;
          align-items: center;
          padding-left: 0 !important;

          span {
            padding-left: 5px !important;
            padding-top: 0;
          }
        }
      }
    }
  }
}
</style>
